import RadioButtonGroup from './RadioButtonGroup';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(RadioButtonGroup);
